import isImmutable from '../isImmutable'
import hint from '../hint'
const hintIm = hint(isImmutable)
export default hintIm
